// Explicit action-gated pages must not inherit access from a permitted parent.
export function canAccessActionRoute(meta, user) {
  return Boolean(user.isAdmin || user.actionPermissions?.includes(meta.requiredActionPermission));
}
